// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__28MbL","log":"ModalInventoryLogs_log__1nnvY","date":"ModalInventoryLogs_date__2lV-H","userName":"ModalInventoryLogs_userName__3ICXj"};